import { fastquote_client, get_fpool_fastquote } from 'src/axios'
import { ax_get_fpool_fastquote, fpool_special, response_t, saga_act } from 'src/types'

import { do_request } from './base.http'

/**
 * Resolve fpool fastquote
 */
export async function http_resolve_fpool_fastquote({
  args,
  type,
}: saga_act<ax_get_fpool_fastquote>): Promise<response_t<fpool_special>> {
  return do_request<fpool_special>({
    client: fastquote_client,
    request: get_fpool_fastquote(args),
    saga_type: type,
  })
}
